import { Table } from 'antd';
import { ExportConfirmDialogWrapper } from '../NXIntegrationPageStyled';
import { NX_INTEGRATION_CONSTANT } from '../constant';

const { TITLE, DIALOG } = NX_INTEGRATION_CONSTANT;

interface ExportConfirmDialogProps {
  open: boolean;
  loading: boolean;
  yearMonthDisplay: string;
  onCancel: () => void;
  onOk: () => void;
}

const columns = [
  { title: '項目名', dataIndex: 'label', key: 'label', width: '40%' },
  { title: '値', dataIndex: 'value', key: 'value' },
];

/**
 * VAMS_PC_010_01 出力確認ダイアログ.
 * [D1] container / [D1.1] close × (same as キャンセル [D4])
 * [D2] confirmation message / [D3] summary table (3 rows: 出力タイプ, 棚卸年月, 出力対象)
 * [D4] キャンセル / [D5] OK (loading during CSV generation)
 */
export function ExportConfirmDialog({
  open,
  loading,
  yearMonthDisplay,
  onCancel,
  onOk,
}: ExportConfirmDialogProps) {
  const dataSource = [
    { key: 'outputType', label: DIALOG.LABEL_OUTPUT_TYPE, value: DIALOG.OUTPUT_TYPE_VALUE },
    { key: 'yearMonth', label: DIALOG.LABEL_YEAR_MONTH, value: yearMonthDisplay || '—' },
    { key: 'exportTarget', label: DIALOG.LABEL_EXPORT_TARGET, value: DIALOG.EXPORT_TARGET_VALUE },
  ];

  return (
    <ExportConfirmDialogWrapper
      open={open}
      title={TITLE.OUTPUT_CONFIRM_TITLE}
      maskClosable={false}
      confirmLoading={loading}
      onCancel={onCancel}
      cancelText={TITLE.BTN_CANCEL}
      okText={TITLE.BTN_OK}
      onOk={onOk}
      width={480}
    >
      <p className="export-confirm_message">{DIALOG.MESSAGE}</p>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        size="small"
        bordered
      />
    </ExportConfirmDialogWrapper>
  );
}
